"use client";

import { c as _c } from "react/compiler-runtime";
import { useSetAtom } from "jotai";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "@/assets/svg/close-icon-banner.svg";
import LeftArrow from "@/assets/svg/text-banner-left-arrow.svg";
import RightArrow from "@/assets/svg/text-banner-r-arrow.svg";
import { useIsMobile } from "@/hooks/use-mobile";
import { getCurrentLanguageInClient } from "@/lib/utils.client";
import { textBannerVisibleAtom } from "@/store/textBannerAtom";
import { CMSPlatformLink } from "../cms/components/cms-items";
import { getTranslatedText } from "../cms/utils.server";

// CSS样式定义
const scrollLeftStyle = `
@keyframes scroll-left {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-100%);
    }
}

.animate-scroll-left {
    animation: scroll-left 10s linear infinite;
}
`;
export function TextBanner(t0) {
  const $ = _c(48);
  const {
    bannerData
  } = t0;
  const lang = getCurrentLanguageInClient();
  const isMobile = useIsMobile();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTextScrolling, setIsTextScrolling] = useState(false);
  const textRef = useRef(null);
  const setBannerVisible = useSetAtom(textBannerVisibleAtom);
  const banners = bannerData?.children || [];
  const currentBanner = banners[currentIndex];
  const bannerText = getTranslatedText(lang, currentBanner?.title_trans || {});
  const buttonText = getTranslatedText(lang, currentBanner?.data?.buttonTitle || {});
  const link = currentBanner?.data?.link;
  let t1;
  if ($[0] !== banners.length || $[1] !== setCurrentIndex) {
    t1 = () => {
      if (banners.length <= 1) {
        return;
      }
      const timer = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % banners.length);
      }, 20000);
      return () => clearInterval(timer);
    };
    $[0] = banners.length;
    $[1] = setCurrentIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== banners.length) {
    t2 = [banners.length];
    $[3] = banners.length;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== setIsTextScrolling) {
    t3 = () => {
      const checkTextOverflow = () => {
        if (textRef.current) {
          const isOverflow = textRef.current.scrollWidth > textRef.current.clientWidth;
          setIsTextScrolling(isOverflow);
        }
      };
      const timer_0 = setTimeout(checkTextOverflow, 100);
      return () => clearTimeout(timer_0);
    };
    $[5] = setIsTextScrolling;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== bannerText) {
    t4 = [bannerText];
    $[7] = bannerText;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== banners.length || $[10] !== setCurrentIndex) {
    t5 = () => {
      setCurrentIndex(prev_0 => (prev_0 - 1 + banners.length) % banners.length);
    };
    $[9] = banners.length;
    $[10] = setCurrentIndex;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handlePrev = t5;
  let t6;
  if ($[12] !== banners.length || $[13] !== setCurrentIndex) {
    t6 = () => {
      setCurrentIndex(prev_1 => (prev_1 + 1) % banners.length);
    };
    $[12] = banners.length;
    $[13] = setCurrentIndex;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleNext = t6;
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <style dangerouslySetInnerHTML={{
      __html: scrollLeftStyle
    }} />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== banners.length || $[17] !== handlePrev) {
    t8 = banners.length > 1 ? <div onClick={handlePrev} className="flex items-center justify-center w-5.5 h-5.5 md:w-8 md:h-8 hover:opacity-80"><LeftArrow className="w-5.5 h-5.5 md:w-8 md:h-8" /></div> : <div className="w-5.5 h-5.5 md:w-8 md:h-8" />;
    $[16] = banners.length;
    $[17] = handlePrev;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = `text-xs md:text-sm text-center block whitespace-nowrap ${isTextScrolling ? "animate-scroll-left" : ""}`;
  const t10 = isTextScrolling ? isMobile ? "8s" : "10s" : "unset";
  const t11 = isTextScrolling ? "infinite" : "unset";
  const t12 = isTextScrolling ? "linear" : "unset";
  let t13;
  if ($[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
    t13 = {
      animationDuration: t10,
      animationIterationCount: t11,
      animationTimingFunction: t12
    };
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== bannerText || $[24] !== t13 || $[25] !== t9) {
    t14 = <div className="relative md:flex-initial max-w-[calc(100vw-140px)] overflow-hidden"><span ref={textRef} className={t9} style={t13}>{bannerText}</span></div>;
    $[23] = bannerText;
    $[24] = t13;
    $[25] = t9;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== buttonText || $[28] !== link) {
    t15 = buttonText && link && <CMSPlatformLink platformLink={link} className=" max-w-50 md:max-w-140 overflow-hidden text-ellipsis whitespace-nowrap inline-block text-xs md:text-sm text-[#D2001E] hover:opacity-80 transition-opacity mt-1 md:mt-0 md:ml-4 shrink-0 underline">{buttonText}</CMSPlatformLink>;
    $[27] = buttonText;
    $[28] = link;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t14 || $[31] !== t15) {
    t16 = <div className="flex-1 flex flex-col items-center justify-center p-2 md:flex-row md:justify-center overflow-hidden">{t14}{t15}</div>;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== banners.length || $[34] !== handleNext) {
    t17 = banners.length > 1 ? <div onClick={handleNext} className="flex items-center justify-center w-5.5 h-5.5 md:w-8 md:h-8 hover:opacity-80"><RightArrow className="w-5.5 h-5.5 md:w-8 md:h-8" /></div> : <div className="w-5.5 h-5.5 md:w-8 md:h-8" />;
    $[33] = banners.length;
    $[34] = handleNext;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t16 || $[37] !== t17 || $[38] !== t8) {
    t18 = <div className=" container mx-auto h-11 px-5 md:pl-[min(calc(60/1920*100vw),60px)] md:pr-[min(calc(60/1920*100vw),60px)] flex items-center justify-between  md:h-11">{t8}{t16}{t17}</div>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t8;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== setBannerVisible) {
    t19 = () => setBannerVisible(false);
    $[40] = setBannerVisible;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <CloseIcon className="w-3 h-3 md:w-4 md:h-4" />;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t19) {
    t21 = <button type="button" onClick={t19} className="absolute top-1 right-1 md:top-1/2 md:-translate-y-1/2  md:right-[40px] flex items-center justify-center w-3 h-3 md:w-4 md:h-4 hover:opacity-80">{t20}</button>;
    $[43] = t19;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t18 || $[46] !== t21) {
    t22 = <>{t7}<div className="w-full bg-[#f4f4f4] text-black relative" data-testid="header-text-banner">{t18}{t21}</div></>;
    $[45] = t18;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  return t22;
}